/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Title_TailInputs */

const en_price_page_title_tail = /** @type {(inputs: Price_Page_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booking stays free.`)
};

const pl_price_page_title_tail = /** @type {(inputs: Price_Page_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezerwacje zostają bez opłat.`)
};

/**
* | output |
* | --- |
* | "Booking stays free." |
*
* @param {Price_Page_Title_TailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_title_tail = /** @type {((inputs?: Price_Page_Title_TailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Title_TailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_title_tail(inputs)
	return en_price_page_title_tail(inputs)
});